class StickyCart {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._spanTag = document.createElement('span')
        this._spanTag.classList.add('sticky-atb__price')
    }

    onInit () {
        this._variantSwitch()
        this._checkVisibility()
        this._scrollToEdit()
        this._stickyClick()
        this._quantityChange()
    }

    // check for variants...
    _variantSwitch () {
        const optionSelector = document.querySelectorAll('.options-selection__input-select')

        const showVariantPrice = () => {
            const variantOptions = document.querySelectorAll('.variant-selection__variants option')
            const btnPriceOptions = document.querySelectorAll('.variant-prices')

            if (variantOptions.length === -1 || btnPriceOptions === -1) return

            let selectedVariant = null

            variantOptions.forEach((variant) => {
                if (variant.selected) {
                    selectedVariant = variant.value
                }
            })

            if (selectedVariant !== null) {
                document.querySelector('.price-on-load').classList.remove('show')
            }

            btnPriceOptions.forEach((btnPrice) => {
                if (btnPrice.id === selectedVariant) {
                    btnPrice.classList.add('show')
                } else {
                    btnPrice.classList.remove('show')
                }
            })

            let addPriceToBtn
            const mainPriceELem = document.querySelector('.price__current .money')
            const pricing = mainPriceELem.textContent

            // update main add to cart button with price...
            if (document.querySelector('.variant-prices.show') != null) {
                addPriceToBtn = pricing
            } else {
                if (document.querySelector('.price-on-load')) {
                    addPriceToBtn = document.querySelector('.price-on-load').innerHTML
                }
            }

            this._spanTag.innerHTML = ` ${addPriceToBtn}`

            const mainCartBtn = document.querySelector('.product-form--atc-button')
            const oldPrice = mainCartBtn.querySelector('.sticky-atb__price')
            if (oldPrice) oldPrice.remove()
            mainCartBtn.insertAdjacentElement('beforeend', this._spanTag)

            this._updatePrice(pricing) // Update the price based on quantity
        }

        showVariantPrice()

        optionSelector.forEach((selector) => {
            selector.addEventListener('change', () => {
                // need to do something better...
                setTimeout(() => {
                    showVariantPrice()
                }, 1000)
            })
        })
    }

    // check if add to cart is on screen
    _checkVisibility () {
        const checkDivVisibility = () => {
            const addToCartBtn = document.querySelector('.product-form--atc-button')
            const stickyContainer = document.querySelector('.sticky-atb-outer')

            if (addToCartBtn) {
                const rect = addToCartBtn.getBoundingClientRect()

                // Check if the div is fully visible
                if (rect.top >= 50) {
                    stickyContainer.classList.remove('show')
                } else {
                    stickyContainer.classList.add('show')
                }
            }
        }
        // need some kind of deBounce wrapper
        window.addEventListener('scroll', checkDivVisibility)
    }

    _quantityChange () {
        const quantitySelector = document.querySelector('.quantity-selector__input')

        // Listen to change and input events on the quantity input
        quantitySelector.addEventListener('change', () => this._updatePrice())
        quantitySelector.addEventListener('input', () => this._updatePrice())

        // Listen to click events on the plus and minus buttons
        const quantityPlusButton = document.querySelector('[data-quantity-plus]')
        const quantityMinusButton = document.querySelector('[data-quantity-minus]')

        quantityPlusButton.addEventListener('click', () => {
            // Wait for the quantity input's value to update before updating the price
            setTimeout(() => this._updatePrice(), 0)
        })

        quantityMinusButton.addEventListener('click', () => {
            // Wait for the quantity input's value to update before updating the price
            setTimeout(() => this._updatePrice(), 0)
        })
    }

    _updatePrice (pricing = false) {
        const quantitySelector = document.querySelector('.quantity-selector__input')
        const quantity = parseInt(quantitySelector.value, 10)

        // Select the original price element
        const priceOnLoadElem = document.querySelector('.price-on-load')

        if (!priceOnLoadElem) return // If no original price is found, exit the function

        // Parse the price from the original price element's text content - not removing comma was causing error
        const originalPrice = parseFloat(priceOnLoadElem.textContent.replace(/,/g, '').trim().substring(1))

        // Calculate the total price
        const totalPrice = quantity * originalPrice
        const formattedTotalPrice = pricing ? ` - ${pricing} ` : ` - £${totalPrice.toFixed(2)}` // Formatted price

        // Update the 'Add to cart' button text with the total price
        const mainCartBtn = document.querySelector('.product-form--atc-button')
        const stickyCartBtn = document.querySelector('.sticky-atb__button')

        // Ensure the buttons exist
        if (mainCartBtn) {
            const mainPriceElem = mainCartBtn.querySelector('.sticky-atb__price')
            if (mainPriceElem) mainPriceElem.textContent = formattedTotalPrice
        }

        if (stickyCartBtn) {
            // Find the price span with the same variant as the selected one
            const variantSpans = stickyCartBtn.querySelectorAll('.variant-prices')
            variantSpans.forEach((span) => {
                if (span.classList.contains('show')) {
                    span.textContent = formattedTotalPrice
                } else if (span.classList.contains('no-variants')) {
                    span.textContent = formattedTotalPrice
                    span.classList.add('show')
                    document.querySelector('.price-on-load').classList.remove('show')
                }
            })
        }
    }

    // on click scroll to edit...
    _scrollToEdit () {
        const editBtn = document.querySelectorAll('.sticky-atb__edit')
        const scrollToSelect = document.querySelector('.product-block--form')

        editBtn.forEach((btn) => {
            btn.addEventListener('click', () => {
                scrollToSelect.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' })
            })
        })
    }

    // listen for clicks on sticky add to cart
    _stickyClick () {
        const stickyAddToCart = document.querySelector('.sticky-atb__button')

        stickyAddToCart.addEventListener('click', () => {
            const addToCartBtn = document.querySelector('.product-form--atc-button')
            addToCartBtn.click()
        })
    }
}

export default StickyCart



// WEBPACK FOOTER //
// ./src/resources/scripts/components/StickyCart.js